import React from 'react';

interface WarningBannerProps {
  message: string
}

export const WarningBanner: React.FC<WarningBannerProps> = ({ message }) => (
  <div
    className="alert alert-warning d-flex align-items-center"
    role="alert"
    style={{
      fontWeight: 500,
      marginTop: '1rem',
      marginBottom: '1rem',
    }}
  >
    <i className="fa fa-exclamation-triangle mr-2" />
    {message}
  </div>
)
